import { Component } from '@angular/core';

@Component({
  selector: 'app-karat-select',
  templateUrl: './karat-select.component.html',
  styleUrls: ['./karat-select.component.scss']
})
export class KaratSelectComponent {

}
